import { doMutation } from "../../core-module/util/graphqlHelper";

export const updateTrainingCategoryStatus = trainingCategory => {
  const mutation = require("../api/mutation/updateTrainingCategoryStatus.gql");
  const variables = { input: trainingCategory };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.createOrUpdateTrainingCategory };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
